import { Button } from '@platform/components';
import { useEffect, useState } from 'react';
import { MovingWorldsBannerLogoLink } from '../../layout/MovingWorldsLogo';
import { LogInBackground } from '../components/LogInBackground';

export const ApplicationStartPage = () => {
  const [isRep, setIsRep] = useState(false);

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);

    if (searchParams.get('is_rep') === 'true') {
      setIsRep(true);
    }
  }, []);

  const onPressContinue = () => {
    if (import.meta.env.VITE_ENVIRONMENT === 'development') {
      window.location.href = 'http://localhost:3000/apply/details?created=1';
    } else {
      window.location.href = '/apply/details?created=1';
    }
  };

  return (
    <LogInBackground>
      <div className='h-full'>
        <div className='md:hidden w-full m-auto text-brand-500 h-16 min-h-16 border-b border-gray-100'>
          <MovingWorldsBannerLogoLink
            className='flex justify-center h-full w-full items-center'
            height='22'
          />
        </div>
        <div className='flex flex-col w-full md:h-full md:w-[400px] px-4 md:px-1 py-8 md:py-0 items-center justify-center'>
          <div className='flex flex-col gap-8'>
            <h3 className='text-display-sm font-gray-700 font-medium'>Welcome! 👋</h3>
            <div>We have a few questions to help you get started.</div>
            <div>
              It will take about {isRep ? '25' : '10'} minutes, and you can edit it later. We'll
              save as you go.
            </div>
            <Button size='lg' variant='primary' onPress={onPressContinue}>
              Continue
            </Button>
          </div>
        </div>
      </div>
    </LogInBackground>
  );
};
